import { render, staticRenderFns } from "./ReportReview_new.vue?vue&type=template&id=d7203914&"
import script from "./ReportReview_new.vue?vue&type=script&lang=js&"
export * from "./ReportReview_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports